import i18n from "@/plugins/i18n";
const errorMessages = {
  500: "System Error",
  504: "Connect Timeout",
  503: "No Connection to BCCS",

  995: "Payment error [995]",

  996: "ABA getStatus: Data not found [996]",

  997: "System Error: Resource not found [997]",

  998: "Not found account info [998]",
  999: "Mini App Error [999]",
};

const getErrorMessage = (code) => {
  console.log("Code: ", code);
  const value = errorMessages[code] || "Network Error";

  return i18n.global.t(value);
};

export default getErrorMessage;
